import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const GalleryIcon = (props: SvgProps) => (
  <Svg
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="M1.677 15.861c-.432 0-.797-.148-1.094-.445a1.486 1.486 0 0 1-.445-1.093V8.957h.924v5.366c0 .154.064.295.192.423s.269.192.423.192h7.366v.923H1.677Zm7.29 0v-.923h5.356a.588.588 0 0 0 .423-.192.588.588 0 0 0 .192-.423V8.957h.923v5.366c0 .432-.148.797-.445 1.093a1.486 1.486 0 0 1-1.093.445H8.966Zm-5.344-3.438 1.87-2.454 1.719 2.054 2.584-3.261 2.75 3.661H3.623ZM.138 9.033V1.678c0-.432.149-.797.445-1.094A1.486 1.486 0 0 1 1.677.138h5.366v.924H1.677a.588.588 0 0 0-.423.192.588.588 0 0 0-.192.423v7.357H.138Zm14.8 0V1.678a.588.588 0 0 0-.192-.423.588.588 0 0 0-.423-.192H5.966V.138h8.357c.432 0 .797.149 1.093.445.297.297.445.662.445 1.094v7.357h-.923Zm-3.675-3.225a1.034 1.034 0 0 1-1.071-1.067A1.034 1.034 0 0 1 11.26 3.67a1.033 1.033 0 0 1 1.071 1.067 1.033 1.033 0 0 1-1.067 1.071Z"
    />
  </Svg>
)
export default GalleryIcon
